import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Trustedecommerceweb() {
  return (
    <section className="trusted_ecommerce_web p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Specialized <span>WooCommerce Web Development</span> Expertise
            </h2>
            <p>
              Maximize your WooCommerce site’s performance with our dedicated
              development team. We deliver precise, technically advanced
              solutions tailored to your eCommerce needs.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={11} xxl={10} className="m-auto">
            <Row className="mt-3 mt-md-4">
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">01</div>
                  <div className="ecomm_box_content">
                    <h5>Custom Plugin Engineering</h5>
                    <p>
                      Deploy specialized WooCommerce plugins built by our expert
                      developers. Enhance site functionality and streamline
                      integration with your business systems.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">02</div>
                  <div className="ecomm_box_content">
                    <h5>PCI-Compliant Payment Integration</h5>
                    <p>
                      Integrate secure payment gateways with strict PCI DSS
                      compliance. Safeguard customer transactions with encrypted
                      data flow and secure processing.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={6}
                xxl={6}
                className="mb-md-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">03</div>
                  <div className="ecomm_box_content">
                    <h5>API Integration & Customization</h5>
                    <p>
                      Leverage RESTful APIs for seamless integration with CRMs,
                      ERPs, and third-party services. Facilitate real-time data
                      transfer and improve operational workflows.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">04</div>
                  <div className="ecomm_box_content">
                    <h5>Performance Tuning & Optimization</h5>
                    <p>
                      Execute advanced performance tuning for faster load times,
                      optimized server response, and efficient resource
                      management. Boost site speed and conversion rates.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Trustedecommerceweb;
